import Openable from './lib/openable';

class Drawer extends Openable {
  constructor(element, options) {
    super(element, options);

    this.classes = {
      active: 'drawer--active',
    };
  }
}

export default (element: string | HTMLElement, options?: Openable['options']): Drawer =>
  new Drawer(element, options);
